import { useSelector } from 'react-redux';

import { useHasGoogleSyncFeature } from 'hooks/useHasGoogleSyncFeature';
import { activeNetworkSelector } from 'redux/selectors';
import { contactSourceOptions } from './defaultFilters';

const GOOGLE_SOURCE_VALUE = 'google_contacts_import';

// Contact source filter options gated by network features. Shared by the
// contacts and hires source filters so gating stays consistent across both.
// The Google source is only surfaced when the active network has google_sync.
export const useContactSourceOptions = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const hasGoogleSyncFeature = useHasGoogleSyncFeature({ network: activeNetwork });

  return hasGoogleSyncFeature
    ? contactSourceOptions
    : contactSourceOptions.filter((option) => !option.value.includes(GOOGLE_SOURCE_VALUE));
};
